
import { Carousel, CarouselContent, CarouselDots, CarouselItem } from '@/components/ui/Carousel'
import { Divider } from '@/components/ui/Divider'
import { Container } from '@/components/ui/template/Container'
import { useWindowSize } from '@/hooks/helpers/useWindowSize'
import Autoplay from 'embla-carousel-autoplay'
import { EndedPolls, OngoingPolls, UpcomingPolls } from './AdminStats'

const STATS = [OngoingPolls, UpcomingPolls, EndedPolls] as const

const STATS_WITH_DIVIDER = STATS.flatMap((stat, index) => {
	return index !== STATS.length - 1
		? [stat, () => <Divider variant="subtle" orientation="vertical" className="h-[56px] border-green-10" />]
		: [stat]
})

function MobileContent() {
	return (
		<Carousel opts={{ loop: true }} plugins={[Autoplay()]}>
			<CarouselContent>
				{STATS.map((Stat, index) => (
					<CarouselItem key={index}>
						<Stat />
					</CarouselItem>
				))}
			</CarouselContent>
			<CarouselDots />
		</Carousel>
	)
}

export function AdminStatsSection() {
	const { isDesktop } = useWindowSize()

	return (
		<Container className="bg-primary">
			<Container.Content className="py-0 h-[124px] lg:min-h-[96px] max-w-[800px] md:py-2 flex flex-col gap-8 lg:flex-row items-center justify-evenly">
				{isDesktop ? (
					STATS_WITH_DIVIDER.map((Stat, index) => <Stat className="flex-1" key={index} />)
				) : (
					<MobileContent />
				)}
			</Container.Content>
		</Container>
	)
}
